/**
 * 从 auth-storage（Zustand persist 的登录态）读取 Valhalla 登录 token（裸 token，无 "Bearer " 前缀）。
 * 找不到 / 解析失败时返回 undefined，调用方据此决定是否附加 Authorization 头。
 */
export function getBearerToken(): string | undefined {
  const raw = localStorage.getItem('auth-storage');
  if (!raw) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(raw) as { state?: { token?: string } };
    return parsed.state?.token;
  } catch {
    return undefined;
  }
}
